"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ArtboardAdd: ['artboard-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,3.5a1,1,0,0,0,1-1V1A1,1,0,0,0,5,1V2.5A1,1,0,0,0,6,3.5Z', 'M2.5,5H1A1,1,0,0,0,1,7H2.5a1,1,0,0,0,0-2Z', 'M2.5,17H1a1,1,0,0,0,0,2H2.5a1,1,0,0,0,0-2Z', 'M18,0a1,1,0,0,0-1,1V2.5a1,1,0,0,0,2,0V1A1,1,0,0,0,18,0Z', 'M6,20.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.5A1,1,0,0,0,6,20.5Z', 'M18,20.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.5A1,1,0,0,0,18,20.5Z', 'M21.5,7H23a1,1,0,0,0,0-2H21.5a1,1,0,0,0,0,2Z', 'M23,17H21.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M18,5H6A1,1,0,0,0,5,6V18a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V6A1,1,0,0,0,18,5Zm-3,6a1,1,0,0,1,0,2H13.25a.25.25,0,0,0-.25.25V15a1,1,0,0,1-2,0V13.25a.25.25,0,0,0-.25-.25H9a1,1,0,0,1,0-2h1.75a.25.25,0,0,0,.25-.25V9a1,1,0,0,1,2,0v1.75a.25.25,0,0,0,.25.25Z']],
  ArtboardShrinkAlternate: ['artboard-shrink-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707.293a1,1,0,0,0-1.414,0L15.611,6.975a.251.251,0,0,1-.23.068A1.838,1.838,0,0,0,15,7H7.25A.25.25,0,0,1,7,6.75V5.5A1.5,1.5,0,0,0,5.5,4h-1A1.5,1.5,0,0,0,3,5.5V6.75A.25.25,0,0,1,2.75,7H1.5A1.5,1.5,0,0,0,0,8.5v1A1.5,1.5,0,0,0,1.5,11H2.75a.25.25,0,0,1,.25.25V19a2,2,0,0,0,2,2h7.75a.25.25,0,0,1,.25.25V22.5A1.5,1.5,0,0,0,14.5,24h1A1.5,1.5,0,0,0,17,22.5V21.25a.25.25,0,0,1,.25-.25H18.5A1.5,1.5,0,0,0,20,19.5v-1A1.5,1.5,0,0,0,18.5,17H17.25a.25.25,0,0,1-.25-.25V9a1.838,1.838,0,0,0-.043-.381.249.249,0,0,1,.068-.229l6.682-6.683A1,1,0,0,0,23.707.293ZM12.5,17H9.018a.25.25,0,0,1-.177-.427l3.732-3.732a.25.25,0,0,1,.427.177V16.5A.5.5,0,0,1,12.5,17ZM7.427,15.159A.25.25,0,0,1,7,14.982V11.5a.5.5,0,0,1,.5-.5h3.482a.25.25,0,0,1,.177.427Z']],
  ArtboardCircle: ['artboard-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,18a1,1,0,0,0-1-1H21.25a.25.25,0,0,1-.25-.25V4.5A1.5,1.5,0,0,0,19.5,3H7.25A.25.25,0,0,1,7,2.75V1A1,1,0,0,0,6,0H4A1,1,0,0,0,3,1V2.75A.25.25,0,0,1,2.75,3H1A1,1,0,0,0,0,4V6A1,1,0,0,0,1,7H2.75A.25.25,0,0,1,3,7.25V19.5A1.5,1.5,0,0,0,4.5,21H16.75a.25.25,0,0,1,.25.25V23a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V21.25a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,1-1Zm-6.5-1a.5.5,0,0,1-.5.5H7a.5.5,0,0,1-.5-.5V7A.5.5,0,0,1,7,6.5H17a.5.5,0,0,1,.5.5Z', 'M8.500 12.000 A3.500 3.500 0 1 0 15.500 12.000 A3.500 3.500 0 1 0 8.500 12.000 Z']],
  ArtboardExpand: ['artboard-expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,17.25H21.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M2.5,5.25H1a1,1,0,0,0,0,2H2.5a1,1,0,0,0,0-2Z', 'M19,7.25a2,2,0,0,0-2-2H7.25A.25.25,0,0,1,7,5V2.25a1,1,0,0,0-2,0v15a2,2,0,0,0,2,2h9.75a.25.25,0,0,1,.25.25v2.75a1,1,0,0,0,2,0Zm-11.5,10a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v9a.5.5,0,0,1-.5.5Z', 'M21.207,4.457l2-2a1,1,0,0,0-1.414-1.414l-2,2a1,1,0,0,0,1.414,1.414Z', 'M15.707,8.543a1,1,0,0,0-1.414,0l-1.5,1.5a1,1,0,1,0,1.414,1.414l1.5-1.5A1,1,0,0,0,15.707,8.543Z', 'M10.293,12.543l-1.5,1.5a1,1,0,1,0,1.414,1.414l1.5-1.5a1,1,0,0,0-1.414-1.414Z']],
  ArtboardShapes: ['artboard-shapes', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,3.5a1,1,0,0,0,1-1V1A1,1,0,0,0,5,1V2.5A1,1,0,0,0,6,3.5Z', 'M2.5,5H1A1,1,0,0,0,1,7H2.5a1,1,0,0,0,0-2Z', 'M2.5,17H1a1,1,0,0,0,0,2H2.5a1,1,0,0,0,0-2Z', 'M18,0a1,1,0,0,0-1,1V2.5a1,1,0,0,0,2,0V1A1,1,0,0,0,18,0Z', 'M6,20.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.5A1,1,0,0,0,6,20.5Z', 'M18,20.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.5A1,1,0,0,0,18,20.5Z', 'M21.5,7H23a1,1,0,0,0,0-2H21.5a1,1,0,0,0,0,2Z', 'M23,17H21.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M12.250 11.250 L15.250 11.250 L15.250 15.250 L12.250 15.250 Z', 'M11.5,9.75a.25.25,0,0,0,.25-.25V9a.25.25,0,0,0-.25-.25H9A.25.25,0,0,0,8.75,9v3.5a.25.25,0,0,0,.25.25h1.5a.25.25,0,0,0,.25-.25v-2A.75.75,0,0,1,11.5,9.75Z', 'M18,5H6A1,1,0,0,0,5,6V18a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V6A1,1,0,0,0,18,5ZM16,9.75a.75.75,0,0,1,.75.75V16a.75.75,0,0,1-.75.75H11.5a.75.75,0,0,1-.75-.75V14.5a.25.25,0,0,0-.25-.25H8a.75.75,0,0,1-.75-.75V8A.75.75,0,0,1,8,7.25h4.5a.75.75,0,0,1,.75.75V9.5a.25.25,0,0,0,.25.25Z']],
  ArtboardSubtract: ['artboard-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,3.5a1,1,0,0,0,1-1V1A1,1,0,0,0,5,1V2.5A1,1,0,0,0,6,3.5Z', 'M2.5,5H1A1,1,0,0,0,1,7H2.5a1,1,0,0,0,0-2Z', 'M2.5,17H1a1,1,0,0,0,0,2H2.5a1,1,0,0,0,0-2Z', 'M18,0a1,1,0,0,0-1,1V2.5a1,1,0,0,0,2,0V1A1,1,0,0,0,18,0Z', 'M6,20.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.5A1,1,0,0,0,6,20.5Z', 'M18,20.5a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.5A1,1,0,0,0,18,20.5Z', 'M21.5,7H23a1,1,0,0,0,0-2H21.5a1,1,0,0,0,0,2Z', 'M23,17H21.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M18,5H6A1,1,0,0,0,5,6V18a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V6A1,1,0,0,0,18,5ZM8,12a1,1,0,0,1,1-1h6a1,1,0,0,1,0,2H9A1,1,0,0,1,8,12Z']],
  ArtboardImage: ['artboard-image', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,17.5A1.5,1.5,0,0,0,22.5,16H21V5a2,2,0,0,0-2-2H8.5V1.5A1.5,1.5,0,0,0,7,0H4.5A1.5,1.5,0,0,0,3,1.5V3H1.5A1.5,1.5,0,0,0,0,4.5V7A1.5,1.5,0,0,0,1.5,8.5H3V19a2,2,0,0,0,2,2H15.5v1.5A1.5,1.5,0,0,0,17,24h2.5A1.5,1.5,0,0,0,21,22.5V21h1.5A1.5,1.5,0,0,0,24,19.5Zm-2,1.25a.25.25,0,0,1-.25.25H20a1,1,0,0,0-1,1v1.75a.25.25,0,0,1-.25.25h-1a.25.25,0,0,1-.25-.25V20a1,1,0,0,0-1-1H5.5a.5.5,0,0,1-.5-.5V7.5a1,1,0,0,0-1-1H2.25A.25.25,0,0,1,2,6.25v-1A.25.25,0,0,1,2.25,5H4A1,1,0,0,0,5,4V2.25A.25.25,0,0,1,5.25,2h1a.25.25,0,0,1,.25.25V4a1,1,0,0,0,1,1h11a.5.5,0,0,1,.5.5V17a1,1,0,0,0,1,1h1.75a.25.25,0,0,1,.25.25Z', 'M13.367,10.848a.751.751,0,0,1,.618-.348.735.735,0,0,1,.632.323l1.928,2.782A.25.25,0,0,0,17,13.463V8.25A1.252,1.252,0,0,0,15.75,7H8.25A1.252,1.252,0,0,0,7,8.25v7.5A1.252,1.252,0,0,0,8.25,17H9.315a.251.251,0,0,0,.211-.116ZM10.5,12A1.5,1.5,0,1,1,12,10.5,1.5,1.5,0,0,1,10.5,12Z', 'M14.241,12.915a.25.25,0,0,0-.417.008l-2.35,3.693a.25.25,0,0,0,.211.384H15.75a1.2,1.2,0,0,0,.829-.339.251.251,0,0,0,.033-.324Z']],
  ArtboardShrink: ['artboard-shrink', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707.293a1,1,0,0,0-1.414,0L15.61,6.975a.249.249,0,0,1-.229.068A1.838,1.838,0,0,0,15,7H8.75a.25.25,0,0,1-.25-.25V5.5A1.5,1.5,0,0,0,7,4H4.5A1.5,1.5,0,0,0,3,5.5V6.75A.25.25,0,0,1,2.75,7H1.5A1.5,1.5,0,0,0,0,8.5V11a1.5,1.5,0,0,0,1.5,1.5H2.75a.25.25,0,0,1,.25.25V19a2,2,0,0,0,2,2h6.25a.25.25,0,0,1,.25.25V22.5A1.5,1.5,0,0,0,13,24h2.5A1.5,1.5,0,0,0,17,22.5V21.25a.25.25,0,0,1,.25-.25H18.5A1.5,1.5,0,0,0,20,19.5v-2A1.5,1.5,0,0,0,18.5,16H17.25a.25.25,0,0,1-.25-.25V9a1.855,1.855,0,0,0-.043-.382.249.249,0,0,1,.068-.229l6.682-6.682A1,1,0,0,0,23.707.293ZM14.5,9a.5.5,0,0,1,.5.5V17a1,1,0,0,0,1,1h1.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H16a1,1,0,0,0-1,1v1.75a.25.25,0,0,1-.25.25h-1a.25.25,0,0,1-.25-.25V20a1,1,0,0,0-1-1h-7a.5.5,0,0,1-.5-.5v-7a1,1,0,0,0-1-1H2.25A.25.25,0,0,1,2,10.25v-1A.25.25,0,0,1,2.25,9H4A1,1,0,0,0,5,8V6.25A.25.25,0,0,1,5.25,6h1a.25.25,0,0,1,.25.25V8a1,1,0,0,0,1,1Z', 'M6.750 10.750 L13.250 10.750 L13.250 17.250 L6.750 17.250 Z']],
  ArtboardImageAlternate: ['artboard-image-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,17H21.25a.25.25,0,0,1-.25-.25V4.5A1.5,1.5,0,0,0,19.5,3H7.25A.25.25,0,0,1,7,2.75V1A1,1,0,0,0,6,0H4A1,1,0,0,0,3,1V2.75A.25.25,0,0,1,2.75,3H1A1,1,0,0,0,0,4V6A1,1,0,0,0,1,7H2.75A.25.25,0,0,1,3,7.25V19.5A1.5,1.5,0,0,0,4.5,21H16.75a.25.25,0,0,1,.25.25V23a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V21.25a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,1-1V18A1,1,0,0,0,23,17Zm-5.5-3.568a.25.25,0,0,1-.482.093L15.2,8.972a.751.751,0,0,0-.671-.472.74.74,0,0,0-.7.426l-2.358,4.911a.25.25,0,0,1-.41.06l-1.5-1.651a.749.749,0,0,0-1.206.132L6.967,14.8a.25.25,0,0,1-.467-.124V7A.5.5,0,0,1,7,6.5H17a.5.5,0,0,1,.5.5Zm-.645,3.725a.25.25,0,0,1-.232.343H7.58a.25.25,0,0,1-.217-.374l1.6-2.809a.25.25,0,0,1,.4-.044L10.945,16a.749.749,0,0,0,1.231-.18l2.015-4.2a.251.251,0,0,1,.458.016Z', 'M8.500 9.000 A1.500 1.500 0 1 0 11.500 9.000 A1.500 1.500 0 1 0 8.500 9.000 Z']]
};
exports["default"] = _default;